<template>
  <div class="task-member-list">
    <div class="team-members">
      <!-- <span class="task-member-list__heading">Team</span> -->
      <template v-for="(member, userId) in goal.members">
        <div v-if="userId === task.createdBy && get_contact_by_id(userId).displayName !== 'N/A' && currentUserAcceptedOrDeclined(userId) !== 2"  :key="userId">

          <el-tooltip class="item" effect="dark" placement="top-start"
            :content="get_contact_by_id(userId).displayName + ' - Administrator'">
            <router-link :to="{ name: 'user', params: { userId: userId }}" :key="'member-'+userId">
              <div class="task-member-list__member">
                <div>
                  <img class="user-mini-image"
                  :src="get_contact_by_id(userId).profilePic|defaultUserPic"/>
                </div>
                <div>
                  <b>{{ get_contact_by_id(userId).displayName }}</b>
                </div>
                <div>
                  <font-awesome-icon size="sm" :icon="['fas', 'crown']" style="margin-left: 0.3em" />
                </div>
                <div v-if="currentUserAcceptedOrDeclined(userId) === 0" style="margin-left: 0.3em">
                  (pending)
                </div>
              </div>
            </router-link>
          </el-tooltip>
        </div>
      </template>

    </div>

    <!-- TODO: Make text clickable and allow user to turn into team goal -->
    <!-- <div style="font-size: 10pt; line-height: 16pt; font-weight: normal" >
      <span class="m-0 p-1">Private goal</span>
    </div>

    <span v-if="currentUserIsAdmin">Current user is Admin</span><br />
    <span v-if="currentUserIsOwner">Current user is Owner</span>
    -->
  </div>

</template>

<script>
// TODO: Why not $models.goalMember.getList()?

export default {
  props: {
    task: {
      required: true,
      type: Object,
    },
    goal: {
      required: true,
      type: Object,
    }
  },
  data: () => ({
  }),
  created() {
    Object.keys(this.goal.members).forEach(memberUserId => {
      this.$api.contact_add_if_not_cached( memberUserId );
    })
  },
  computed: {
    /* TODO: Move to model getter */
    /*currentUserIsAdmin() {
      let members = this.goal.members;
      if ( this.userAuth.id in members && members[this.userAuth.id] ) {
        return members[this.userAuth.id].isAdmin;
      }
      return false;
    },

    currentUserIsOwner() {
      let members = this.goal.members;
      if ( this.userAuth.id in members && members[this.userAuth.id] ) {
        return members[this.userAuth.id].isOwner;
      }
      return false;
    },*/

  },
  methods: {
    get_contact_by_id(userId) {
      return this.$models.userContact.get_contact_by_id( userId )
    },

    currentUserAcceptedOrDeclined(userId) {
      let members = this.goal.members;
      let currentUserId = this.$models.user.defaultUserId;
      if ( userId in members && members[ currentUserId ] ) {
        return members[userId].acceptOrDecline;
      }
      return false;
    }/*,
    currentUserIsAdmin(userId) {
      let members = this.goal.members;
      if ( userId in members && members[this.userAuth.id] ) {
        return members[userId].isAdmin;
      }
      return false;
    },*/
  },
  components: {
  }
};
</script>

<style>
.task-member-list .text-header { /* TODO: duplicate css, see goalmemberlist.vue */
  cursor: text;
  /* margin: 0; */
  /* margin-right: 55px; */
  padding: 1px 5px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 10px;
  align-items: flex-start;
}
.task-member-list .text-header:hover {
  border: 1px dashed gray;
  padding: 0 4px;
}
.task-member-list .team-members {
  line-height: 1.2em;
  font-weight: normal;
  margin: 0 0 0 0;
  padding: 3px 0;
  top: -5px;
  position: relative;
}
.task-member-list__member {
  display: flex;
  flex-wrap: nowrap;
  margin-right: 2px;
  /*
  padding: 1px 6px;
  margin: 5px
  */
}
.task-member-list img.user-mini-image {
  height: 20px;
  background-size: cover;
  width: 20px;
  margin-right: 5px;
  border-radius: 50%;
}
.task-member-list__heading {
  font-weight: bold;
  font-size: 10pt;
}
</style>
